import store from '@/store';

import { getUUID } from './getUuid';
import { notAuthHandler } from './notAuthHandler';
import { peerConnectedHandler } from './peerConnectedHandler';

export const userAddedToWhiteListHandler = async (data: {
    device_id: string;
    user_id?: string;
    event: string;
}) => {
    const userId = store.getState().userReducer.user.id;
    const uuids = await getUUID();
    const uuid = uuids.find(
        el => el.uuid === data?.device_id && el.user_id === data?.user_id,
    );

    if (uuid && userId === data.user_id) {
        notAuthHandler(null, true);
        peerConnectedHandler();
    }
};
